import urlApi from '../../router/urlApi'
import { Serialize } from '../../services/serializeFormData'
import { LoadFormData } from '../../services/LoadFormData'
import Vue from 'vue'
import Toast from 'vue-toasted'
import router from '../../router'

const toastOptions = {
  theme: 'none',
  position: 'bottom-center',
  className: 'vuestic-toast',
  iconPack: 'fontawesome',
  duration: 5000
}

Vue.use(Toast, toastOptions)
export default {

  store () {
    let self = this

    self.disableButtons(true)

    Vue.http.post(urlApi + '/veiculos', Serialize.toObject('form_veiculos')).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        self.pageListarVeiculos()
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    })
  },

  update (idVeiculo) {
    let self = this
    self.disableButtons(true)
    Vue.http.patch(urlApi + '/veiculos/' + idVeiculo, Serialize.toObject('form_veiculos')).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        self.pageListarVeiculos()
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    })
  },

  atualizaStatus: function (idVeiculo, status, callback) {
    let self = this

    Vue.http.patch(urlApi + '/veiculos/' + idVeiculo + '/' + status, []).then(function (response) {
      if (response.data.sucesso) {
        self.launchToast('fa-check', 'Status atualizado!')
      } else {
        self.launchToast('fa-check', 'Erro ao tentar atualizar o status!')
      }
      callback()
    })
  },

  getVeiculoById: function (idVeiculo, callback) {
    Vue.http.get(urlApi + '/veiculos/' + idVeiculo).then(function (response) {
      callback(response)
    })
  },

  getCategoria (callback) {
    Vue.http.get(urlApi + '/categorias').then((response) => {
      callback(response.data)
    })
  },

  pageListarVeiculos () {
    router.push({ name: 'listagem-veiculos' })
  },

  paginaEdicao (idVeiculo) {
    router.push({ name: 'editar-veiculo', params: { idVeiculo: idVeiculo } })
  },

  carregaFormularioDeEdicao (idContato) {
    Vue.http.get(urlApi + '/veiculos/' + idContato).then((response) => {
      LoadFormData.byIdInputs(response.data.dados)
    })
  },

  disableButtons (status) {
    document.getElementById('btn_salvar').disabled = status
    document.getElementById('btn_limpar').disabled = status
  },

  launchToast (icon, msg) {
    Vue.toasted.show(msg, {
      icon: icon,
      position: 'top-right',
      duration: 5000,
      fullWidth: false
    }
    )
  }

}
